import { render } from "./TheProducts.vue?vue&type=template&id=9583cb1a&scoped=true&lang=pug&bindings={\"products\":\"setup\",\"slideCurrentInit\":\"setup\",\"slideGroup\":\"setup\",\"show\":\"setup\",\"getSliderGroup\":\"setup\",\"className\":\"setup\",\"el\":\"setup\"}"
import script from "./TheProducts.vue?vue&type=script&lang=js"
export * from "./TheProducts.vue?vue&type=script&lang=js"

import "./TheProducts.vue?vue&type=style&index=0&id=9583cb1a&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-9583cb1a"

export default script